import React from "react";
import PropTypes from "prop-types";
import { FormControl, TextField, Select, MenuItem } from "@mui/material";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getFieldLabel, getPhoneErrorMessage } from "./userProfileHelpers";

export const AccountField = ({ profileSection, account, businessReadOnly, companyName, isOemAdmin, handleFieldChange, inputCompNameErrMsg, profileReadOnly }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName">
      {profileSection ? "Account" : "Business Entity Name"} <span style={{ color: "red" }}>*</span>
    </label>
    {profileSection ? (
      <TextField
        className="inputCls"
        disabled
        fullWidth
        autoComplete="off"
        id="account"
        value={account}
        slotProps={{ input: { readOnly: profileReadOnly } }}
      />
    ) : (
      <TextField
        className="inputCls"
        fullWidth
        autoComplete="off"
        disabled={isOemAdmin ? "true" : businessReadOnly}
        id="corporateCompanyName"
        value={companyName}
        onChange={handleFieldChange}
        slotProps={{ input: { readOnly: businessReadOnly } }}
      />
    )}
    {inputCompNameErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCompNameErrMsg}</span>}
  </FormControl>
);

AccountField.propTypes = {
  profileSection: PropTypes.bool,
  account: PropTypes.string,
  businessReadOnly: PropTypes.bool,
  companyName: PropTypes.string,
  isOemAdmin: PropTypes.bool,
  handleFieldChange: PropTypes.func.isRequired,
  inputCompNameErrMsg: PropTypes.string,
  profileReadOnly: PropTypes.bool
};

export const ContactNameField = ({ profileSection, isIdpLogin, profileReadOnly, corporateContactName, handleContactNameChange, inputCrpNameErrMsg, businessReadOnly, companyWebsite, handleWebsiteChange, inputCompWebsiteErrMsg, isOemAdmin }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName">
      {getFieldLabel(profileSection, "contactName", isIdpLogin)}
      {!isIdpLogin && <span style={{ color: "red" }}>*</span>}
    </label>
    {profileSection ? (
      !isIdpLogin && (
        <TextField
          className="inputCls"
          disabled={profileReadOnly}
          fullWidth
          autoComplete="off"
          id="corporateContactName"
          onChange={handleContactNameChange}
          value={corporateContactName}
          slotProps={{ input: { readOnly: profileReadOnly } }}
        />
      )
    ) : (
      <TextField
        className="inputCls"
        autoComplete="off"
        disabled={isOemAdmin ? "true" : businessReadOnly}
        fullWidth
        id="corportateCompanyWebsite"
        value={companyWebsite}
        onChange={handleWebsiteChange}
        slotProps={{ input: { readOnly: businessReadOnly } }}
      />
    )}
    {profileSection
      ? inputCrpNameErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCrpNameErrMsg}</span>
      : inputCompWebsiteErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCompWebsiteErrMsg}</span>}
  </FormControl>
);

ContactNameField.propTypes = {
  profileSection: PropTypes.bool,
  isIdpLogin: PropTypes.bool,
  profileReadOnly: PropTypes.bool,
  corporateContactName: PropTypes.string,
  handleContactNameChange: PropTypes.func.isRequired,
  inputCrpNameErrMsg: PropTypes.string,
  businessReadOnly: PropTypes.bool,
  companyWebsite: PropTypes.string,
  handleWebsiteChange: PropTypes.func.isRequired,
  inputCompWebsiteErrMsg: PropTypes.string,
  isOemAdmin: PropTypes.bool
};

export const ContactEmailField = ({ profileSection, isIdpLogin, profileReadOnly, corporateContactEmail, handleEmailChange, inputCrpEmailErrMsg, businessReadOnly, registrationCourt, handleCourtChange, inputRegistrationCourt }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName">
      {getFieldLabel(profileSection, "contactEmail", isIdpLogin)}
      {!isIdpLogin && <span style={{ color: "red" }}>*</span>}
    </label>
    {profileSection ? (
      !isIdpLogin && (
        <TextField
          className="inputCls"
          type="email"
          disabled={profileReadOnly}
          autoComplete="off"
          fullWidth
          id="corporateContactEmail"
          value={corporateContactEmail}
          onChange={handleEmailChange}
          slotProps={{ input: { readOnly: profileReadOnly } }}
        />
      )
    ) : (
      <TextField
        className="inputCls"
        type="text"
        disabled={businessReadOnly}
        autoComplete="off"
        fullWidth
        id="registrationCourt"
        value={registrationCourt}
        onChange={handleCourtChange}
        slotProps={{ input: { readOnly: businessReadOnly } }}
      />
    )}
    {profileSection
      ? inputCrpEmailErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCrpEmailErrMsg}</span>
      : inputRegistrationCourt && <span style={{ color: "red", fontSize: "12px" }}>{inputRegistrationCourt}</span>}
  </FormControl>
);

ContactEmailField.propTypes = {
  profileSection: PropTypes.bool,
  isIdpLogin: PropTypes.bool,
  profileReadOnly: PropTypes.bool,
  corporateContactEmail: PropTypes.string,
  handleEmailChange: PropTypes.func.isRequired,
  inputCrpEmailErrMsg: PropTypes.string,
  businessReadOnly: PropTypes.bool,
  registrationCourt: PropTypes.string,
  handleCourtChange: PropTypes.func.isRequired,
  inputRegistrationCourt: PropTypes.string
};

export const PhoneField = ({ profileSection, isIdpLogin, profileReadOnly, phoneNumber, setPhoneNumber, businessReadOnly, companyRegNumber, handleRegNumberChange, inputRegNumberErrMsg }) => {
  const renderProfilePhoneField = () => {
    if (profileReadOnly) {
      return (
        <TextField
          className="inputCls"
          disabled={profileReadOnly}
          fullWidth
          autoComplete="off"
          id="phoneNumber"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          slotProps={{ input: { readOnly: profileReadOnly } }}
        />
      );
    }
    return (
      <PhoneInput
        international
        country="IN"
        defaultCountry="IN"
        value={phoneNumber}
        onChange={setPhoneNumber}
        countryCallingCodeEditable={false}
        error={phoneNumber ? getPhoneErrorMessage(phoneNumber, isValidPhoneNumber(phoneNumber)) : undefined}
      />
    );
  };

  return (
    <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
      <label className="labelName">
        {getFieldLabel(profileSection, "phoneNumber", isIdpLogin)}
        {!isIdpLogin && <span style={{ color: "red" }}>*</span>}
      </label>
      {profileSection ? (
        !isIdpLogin && renderProfilePhoneField()
      ) : (
        <TextField
          className="inputCls"
          disabled={businessReadOnly}
          fullWidth
          autoComplete="off"
          id="companyRegNumber"
          value={companyRegNumber}
          onChange={handleRegNumberChange}
          slotProps={{ input: { readOnly: businessReadOnly } }}
        />
      )}
      {profileSection
        ? phoneNumber && !isValidPhoneNumber(phoneNumber) && (
            <span style={{ color: "red", fontSize: "12px" }}>Invalid phone number</span>
          )
        : inputRegNumberErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputRegNumberErrMsg}</span>}
    </FormControl>
  );
};

PhoneField.propTypes = {
  profileSection: PropTypes.bool,
  isIdpLogin: PropTypes.bool,
  profileReadOnly: PropTypes.bool,
  phoneNumber: PropTypes.string,
  setPhoneNumber: PropTypes.func.isRequired,
  businessReadOnly: PropTypes.bool,
  companyRegNumber: PropTypes.string,
  handleRegNumberChange: PropTypes.func.isRequired,
  inputRegNumberErrMsg: PropTypes.string
};

export const PrivacyPolicyField = ({ readOnlyValue, privacyPolicy, handlePrivacyChange, inputPrivacyLinkErrMsg, isOemAdmin, isIdpLogin }) => (
  !isIdpLogin && (
    <FormControl style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <label className="labelName" htmlFor="privacyPolicy">
        Privacy Policy <span style={{ color: "red", display: isOemAdmin && "none" }}>*</span>
      </label>
      <TextField
        className="inputCls"
        disabled={readOnlyValue}
        autoComplete="off"
        placeholder="https://"
        fullWidth
        sx={{ ".MuiInputBase-input": { fontSize: "14px !important" } }}
        id="privacyPolicy"
        value={privacyPolicy}
        onChange={handlePrivacyChange}
        slotProps={{ input: { readOnly: readOnlyValue } }}
      />
      {inputPrivacyLinkErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputPrivacyLinkErrMsg}</span>}
    </FormControl>
  )
);

PrivacyPolicyField.propTypes = {
  readOnlyValue: PropTypes.bool,
  privacyPolicy: PropTypes.string,
  handlePrivacyChange: PropTypes.func.isRequired,
  inputPrivacyLinkErrMsg: PropTypes.string,
  isOemAdmin: PropTypes.bool,
  isIdpLogin: PropTypes.bool
};

export const CountrySelect = ({ businessReadOnly, countryOfReg, handleCountryChange, countries, inputCountryRegErrMsg, isRegistration }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName">
      {isRegistration ? "Country of Registration" : "Company Country"}
      <span style={{ color: "red" }}>*</span>
    </label>
    <Select
      className="inputCls"
      disabled={businessReadOnly}
      fullWidth
      id={isRegistration ? "countryOfReg" : "countryOfCompany"}
      value={countryOfReg}
      onChange={(e) => handleCountryChange(e, isRegistration)}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) return <em style={{ color: "#999" }}>Select a country</em>;
        const selectedCountry = countries.find((country) => country.id === selected);
        return selectedCountry ? selectedCountry.name : selected;
      }}
      sx={{
        height: "40px",
        fontSize: "14px",
        "& .MuiSelect-select": { padding: "8px 14px" },
        "&.Mui-disabled": { backgroundColor: "#f5f5f5" },
      }}
    >
      <MenuItem value="" disabled><em>Select a country</em></MenuItem>
      {countries?.length > 0 ? (
        countries.map((country) => (
          <MenuItem key={country.id} value={country.id} sx={{ fontSize: "14px", "&:hover": { backgroundColor: "#f5f5f5" } }}>
            {country.name}
          </MenuItem>
        ))
      ) : (
        <MenuItem value="" disabled><em>No countries available</em></MenuItem>
      )}
    </Select>
    {inputCountryRegErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCountryRegErrMsg}</span>}
  </FormControl>
);

CountrySelect.propTypes = {
  businessReadOnly: PropTypes.bool,
  countryOfReg: PropTypes.string,
  handleCountryChange: PropTypes.func.isRequired,
  countries: PropTypes.array,
  inputCountryRegErrMsg: PropTypes.string,
  isRegistration: PropTypes.bool
};

export const AddressField = ({ businessReadOnly, address, handleAddressChange, inputAddressErrMsg }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "100%" }}>
    <label className="labelName" htmlFor="address">
      Address <span style={{ color: "red" }}>*</span>
    </label>
    <TextField
      className="inputCls"
      disabled={businessReadOnly}
      autoComplete="off"
      fullWidth
      id="address"
      value={address}
      onChange={handleAddressChange}
      slotProps={{ input: { readOnly: businessReadOnly } }}
    />
    {inputAddressErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputAddressErrMsg}</span>}
  </FormControl>
);

AddressField.propTypes = {
  businessReadOnly: PropTypes.bool,
  address: PropTypes.string,
  handleAddressChange: PropTypes.func.isRequired,
  inputAddressErrMsg: PropTypes.string
};

export const CityField = ({ businessReadOnly, corporateCompanyCity, handleCityChange, inputCorporateCompanyCity }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName" htmlFor="corporateCompanyCity">
      Company City<span style={{ color: "red" }}>*</span>
    </label>
    <TextField
      className="inputCls"
      type="text"
      disabled={businessReadOnly}
      autoComplete="off"
      fullWidth
      id="corporateCompanyCity"
      value={corporateCompanyCity}
      onChange={handleCityChange}
      slotProps={{ input: { readOnly: businessReadOnly } }}
    />
    {inputCorporateCompanyCity && <span style={{ color: "red", fontSize: "12px" }}>{inputCorporateCompanyCity}</span>}
  </FormControl>
);

CityField.propTypes = {
  businessReadOnly: PropTypes.bool,
  corporateCompanyCity: PropTypes.string,
  handleCityChange: PropTypes.func.isRequired,
  inputCorporateCompanyCity: PropTypes.string
};

export const StateField = ({ businessReadOnly, corporateCompanyState, handleStateChange, inputCorporateCompanyState, isOemAdmin }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName" htmlFor="corporateCompanyState">
      Company state<span style={{ color: "red", display: isOemAdmin && "none" }}>*</span>
    </label>
    <TextField
      className="inputCls"
      disabled={businessReadOnly}
      fullWidth
      autoComplete="off"
      id="corporateCompanyState"
      value={corporateCompanyState}
      onChange={handleStateChange}
      slotProps={{ input: { readOnly: businessReadOnly } }}
    />
    {inputCorporateCompanyState && <span style={{ color: "red", fontSize: "12px" }}>{inputCorporateCompanyState}</span>}
  </FormControl>
);

StateField.propTypes = {
  businessReadOnly: PropTypes.bool,
  corporateCompanyState: PropTypes.string,
  handleStateChange: PropTypes.func.isRequired,
  inputCorporateCompanyState: PropTypes.string,
  isOemAdmin: PropTypes.bool
};

export const ZipField = ({ businessReadOnly, corporateCompanyZip, handleZipChange, inputCorporateCompanyZip }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName" htmlFor="corporateCompanyZip">
      Company ZIP<span style={{ color: "red" }}>*</span>
    </label>
    <TextField
      className="inputCls"
      disabled={businessReadOnly}
      autoComplete="off"
      fullWidth
      id="corporateCompanyZip"
      value={corporateCompanyZip}
      onChange={handleZipChange}
      slotProps={{ input: { readOnly: businessReadOnly } }}
    />
    {inputCorporateCompanyZip && <span style={{ color: "red", fontSize: "12px" }}>{inputCorporateCompanyZip}</span>}
  </FormControl>
);

ZipField.propTypes = {
  businessReadOnly: PropTypes.bool,
  corporateCompanyZip: PropTypes.string,
  handleZipChange: PropTypes.func.isRequired,
  inputCorporateCompanyZip: PropTypes.string
};

export const CompanyPhoneField = ({ businessReadOnly, companyPhoneNumber, setCompanyPhoneNumber }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName" htmlFor="companyPhoneNumber">
      Company Contact Number<span style={{ color: "red" }}>*</span>
    </label>
    {businessReadOnly ? (
      <TextField
        className="inputCls"
        disabled={businessReadOnly}
        fullWidth
        autoComplete="off"
        id="companyPhoneNumber"
        value={companyPhoneNumber}
        onChange={(e) => setCompanyPhoneNumber(e.target.value)}
        slotProps={{ input: { readOnly: businessReadOnly } }}
      />
    ) : (
      <PhoneInput
        international
        country="IN"
        defaultCountry="IN"
        value={companyPhoneNumber}
        onChange={setCompanyPhoneNumber}
        countryCallingCodeEditable={false}
        error={(() => {
          if (!companyPhoneNumber) return "Phone number required";
          return isValidPhoneNumber(companyPhoneNumber) ? undefined : "Invalid phone number";
        })()}
      />
    )}
    {companyPhoneNumber && !isValidPhoneNumber(companyPhoneNumber) && (
      <span style={{ color: "red", fontSize: "12px" }}>Invalid phone number</span>
    )}
  </FormControl>
);

CompanyPhoneField.propTypes = {
  businessReadOnly: PropTypes.bool,
  companyPhoneNumber: PropTypes.string,
  setCompanyPhoneNumber: PropTypes.func.isRequired
};

export const CompanyEmailField = ({ businessReadOnly, companyEmail, handleCompanyEmailChange, inputCompanyEmailErrMsg, isOemAdmin }) => (
  <FormControl style={{ display: "flex", flexDirection: "column", width: "48%" }}>
    <label className="labelName" htmlFor="companyEmail">
      Company Email<span style={{ color: "red", display: isOemAdmin && "none" }}>*</span>
    </label>
    <TextField
      className="inputCls"
      disabled={businessReadOnly}
      fullWidth
      autoComplete="off"
      id="companyEmail"
      value={companyEmail}
      onChange={handleCompanyEmailChange}
      slotProps={{ input: { readOnly: businessReadOnly } }}
    />
    {inputCompanyEmailErrMsg && <span style={{ color: "red", fontSize: "12px" }}>{inputCompanyEmailErrMsg}</span>}
  </FormControl>
);

CompanyEmailField.propTypes = {
  businessReadOnly: PropTypes.bool,
  companyEmail: PropTypes.string,
  handleCompanyEmailChange: PropTypes.func.isRequired,
  inputCompanyEmailErrMsg: PropTypes.string,
  isOemAdmin: PropTypes.bool
};

export const BusinessSectionFields = ({ businessSection, businessReadOnly, countryOfReg, handleCountryChange, countries, inputCountryRegErrMsg, address, handleAddressChange, inputAddressErrMsg, corporateCompanyCity, handleCityChange, inputCorporateCompanyCity, corporateCompanyState, handleStateChange, inputCorporateCompanyState, isOemAdmin, corporateCompanyZip, handleZipChange, inputCorporateCompanyZip, countryOfCompany, inputCountryCompanyErrMsg, companyPhoneNumber, setCompanyPhoneNumber, companyEmail, handleCompanyEmailChange, inputCompanyEmailErrMsg }) => {
  if (!businessSection) return null;
  
  return (
    <>
      <div className="accountControlCls">
        <CountrySelect
          businessReadOnly={businessReadOnly}
          countryOfReg={countryOfReg}
          handleCountryChange={handleCountryChange}
          countries={countries}
          inputCountryRegErrMsg={inputCountryRegErrMsg}
          isRegistration={true}
        />
      </div>
      <div className="accountControlCls">
        <AddressField
          businessReadOnly={businessReadOnly}
          address={address}
          handleAddressChange={handleAddressChange}
          inputAddressErrMsg={inputAddressErrMsg}
        />
      </div>
      <div className="accountControlCls">
        <CityField
          businessReadOnly={businessReadOnly}
          corporateCompanyCity={corporateCompanyCity}
          handleCityChange={handleCityChange}
          inputCorporateCompanyCity={inputCorporateCompanyCity}
        />
        <StateField
          businessReadOnly={businessReadOnly}
          corporateCompanyState={corporateCompanyState}
          handleStateChange={handleStateChange}
          inputCorporateCompanyState={inputCorporateCompanyState}
          isOemAdmin={isOemAdmin}
        />
      </div>
      <div className="accountControlCls">
        <ZipField
          businessReadOnly={businessReadOnly}
          corporateCompanyZip={corporateCompanyZip}
          handleZipChange={handleZipChange}
          inputCorporateCompanyZip={inputCorporateCompanyZip}
        />
        <CountrySelect
          businessReadOnly={businessReadOnly}
          countryOfReg={countryOfCompany}
          handleCountryChange={handleCountryChange}
          countries={countries}
          inputCountryRegErrMsg={inputCountryCompanyErrMsg}
          isRegistration={false}
        />
      </div>
      <div className="accountControlCls">
        <CompanyPhoneField
          businessReadOnly={businessReadOnly}
          companyPhoneNumber={companyPhoneNumber}
          setCompanyPhoneNumber={setCompanyPhoneNumber}
        />
        <CompanyEmailField
          businessReadOnly={businessReadOnly}
          companyEmail={companyEmail}
          handleCompanyEmailChange={handleCompanyEmailChange}
          inputCompanyEmailErrMsg={inputCompanyEmailErrMsg}
          isOemAdmin={isOemAdmin}
        />
      </div>
    </>
  );
};

BusinessSectionFields.propTypes = {
  businessSection: PropTypes.bool,
  businessReadOnly: PropTypes.bool,
  countryOfReg: PropTypes.string,
  handleCountryChange: PropTypes.func.isRequired,
  countries: PropTypes.array,
  inputCountryRegErrMsg: PropTypes.string,
  address: PropTypes.string,
  handleAddressChange: PropTypes.func.isRequired,
  inputAddressErrMsg: PropTypes.string,
  corporateCompanyCity: PropTypes.string,
  handleCityChange: PropTypes.func.isRequired,
  inputCorporateCompanyCity: PropTypes.string,
  corporateCompanyState: PropTypes.string,
  handleStateChange: PropTypes.func.isRequired,
  inputCorporateCompanyState: PropTypes.string,
  isOemAdmin: PropTypes.bool,
  corporateCompanyZip: PropTypes.string,
  handleZipChange: PropTypes.func.isRequired,
  inputCorporateCompanyZip: PropTypes.string,
  countryOfCompany: PropTypes.string,
  inputCountryCompanyErrMsg: PropTypes.string,
  companyPhoneNumber: PropTypes.string,
  setCompanyPhoneNumber: PropTypes.func.isRequired,
  companyEmail: PropTypes.string,
  handleCompanyEmailChange: PropTypes.func.isRequired,
  inputCompanyEmailErrMsg: PropTypes.string
};

export const AgreementDialogActions = ({ agreementDetails, agreementDetailsData, agreementStatus, agreement_accepted, disableSubmitAgreement, allBusinessValid, allProfileValid, handleAgreementChange, handleDisagree, handleAcceptAgreement, Button, Checkbox, Tooltip }) => {
  const currentAgreementDetails = agreementDetails || agreementDetailsData;
  const currentStatus = currentAgreementDetails?.status;
  const hasNewUpdate = currentAgreementDetails?.isNewAgreementAvailable;
  const showActions = !agreementStatus || currentStatus === 'NOT_ACCEPTED' || currentStatus === 'NEW_UPDATE_AVAILABLE' || currentStatus === 'REJECTED' || hasNewUpdate;

  if (!showActions) return null;

  const getTooltipMessage = () => {
    if (!agreement_accepted || !disableSubmitAgreement) return "";
    if (!allBusinessValid && !allProfileValid) {
      return 'Complete all required fields in "Profile Info" and "Business Info" to enable this action.';
    }
    if (allBusinessValid && !allProfileValid) {
      return 'Complete all required fields in "Profile Info" to enable this action.';
    }
    if (!allBusinessValid && allProfileValid) {
      return 'Complete all required fields in "Business Info" to enable this action.';
    }
    return "";
  };

  const tooltipMessage = getTooltipMessage();

  return (
    <div style={{ justifyContent: "space-between", display: "flex", padding: "8px 24px" }}>
      <div className="checkAgreeCls">
        <Checkbox
          checked={agreement_accepted}
          size="small"
          onChange={handleAgreementChange}
          slotProps={{ input: { 'aria-label': 'controlled' } }}
        />
        <span>I agree to the updated Terms</span>
      </div>
      <div>
        <Button
          className="editBtnCls"
          variant="outlined"
          onClick={handleDisagree}
        >
          Disagree
        </Button>
        &nbsp;&nbsp;
        <Tooltip title={tooltipMessage} placement="top">
          <span>
            <Button
              style={{
                background: "221.2 83.2% 53.3%",
                textTransform: "none",
                height: "32px",
                width: "116px",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "16.41px",
                boxShadow: "none",
              }}
              variant="contained"
              onClick={handleAcceptAgreement}
              disabled={disableSubmitAgreement}
            >
              Accept
            </Button>
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

AgreementDialogActions.propTypes = {
  agreementDetails: PropTypes.object,
  agreementDetailsData: PropTypes.object,
  agreementStatus: PropTypes.bool,
  agreement_accepted: PropTypes.bool,
  disableSubmitAgreement: PropTypes.bool,
  allBusinessValid: PropTypes.bool,
  allProfileValid: PropTypes.bool,
  handleAgreementChange: PropTypes.func.isRequired,
  handleDisagree: PropTypes.func.isRequired,
  handleAcceptAgreement: PropTypes.func.isRequired,
  Button: PropTypes.elementType.isRequired,
  Checkbox: PropTypes.elementType.isRequired,
  Tooltip: PropTypes.elementType.isRequired
};
